import {createContext, useContext} from "react";
import {UserDto, UserRoleType} from "../../client/user/User";

export interface UserContextModel {
    user?: UserDto;
    validRoles?: UserRoleType[];
}
const UserContext = createContext<UserContextModel>({});

export default UserContext;

export function useUser() {
    const {user} = useContext(UserContext);
    return user;
}

export function useUserRoles() {
    const {validRoles} = useContext(UserContext);
    return validRoles;
}